import { Container } from 'components/container'
import { IconFacebook } from 'components/icons/facebook'
import { IconInstagram } from 'components/icons/instagram'
import { IconTelegram } from 'components/icons/telegram'
import { IconTwitter } from 'components/icons/twitter'
import { IconVk } from 'components/icons/vk'
import { Layout } from 'components/layout'
import { Content, ShareMenu } from './styled'

const socialLinks = [
  { link: 'https://www.facebook.com/radiosvoboda', icon: <IconFacebook /> },
  { link: 'https://vk.com/public12637912', icon: <IconVk /> },
  { link: 'https://twitter.com/SvobodaRadio', icon: <IconTwitter /> },
  { link: 'https://t.me/radiosvoboda', icon: <IconTelegram /> },
  { link: 'https://www.instagram.com/radiosvoboda/', icon: <IconInstagram /> },
]

export const About = () => (
  <Layout noFooter>
    <Container>
      <Content>
        <h2>O проекте</h2>

        <p>
          В этом году Радио Свобода празднует юбилей. О том, что за эти семь
          десятилетий происходило в мире и на волнах радио - в нашем новом
          проекте "70 лет Свободы"
        </p>

        <h3>Над проектом работали:</h3>

        <p>Авторы: Иван Толстой, Антон Ширяев</p>
        <p>Дизайнер: Лина Ширяева</p>
        <p>Дизайн и разработка сайта: Pangea Digital Data Visualizition team</p>
        <p>Радио Свобода © 2023 RFE/RL, Inc. | Все права защищены.</p>

        <h3>Подпишитесь на нас</h3>

        <ShareMenu>
          {socialLinks.map(l => (
            <li key={l.link}>
              <a href={l.link} rel="noreferrer" target="_blank">
                {l.icon}
              </a>
            </li>
          ))}
        </ShareMenu>
      </Content>
    </Container>
  </Layout>
)
